// ShortsRow.js
import { connect } from 'react-redux';

import fetchFeeds from '../action/fetchFeeds.js';
import FeedStoryProvider from '../container/FeedStoryProvider.js';
import StoryRow from '../component/StoryRow.jsx';

const mapStateToProps = (state, { isProfileCategory }) => {
  return isProfileCategory
    ? {
        isShorts: true,
      }
    : {
        moreLink: '/shorts',
        nextPage: null,
        lastPage: null,
        scrollLeft: 0,
        isShorts: true,
        listPath: null,
        isFirstPageFetched: false, // shorts row should always trigger fetchFirstPage to get randomly data
      };
};

const mapDispatchToProps = (dispatch, { category }) => {
  return {
    setScrollLeft: () => null,
    fetchFirstPage: (data = {}) =>
      dispatch(
        fetchFeeds({
          limit: 20,
          type: category,
          isAllowSameId: true,
          shouldReplaceIds: true,
          shouldIgnorePage: true,
          shouldSkipLocalCache: true,
          ...data,
        })
      ),
  };
};

export default FeedStoryProvider(
  connect(mapStateToProps, mapDispatchToProps)(StoryRow)
);
